<template>
  <div class="left-menu">
    <el-menu :default-active="current">
      <template v-for="(item, idx) in menus">
        <el-menu-item
          v-if="!item.children"
          :key="idx"
          :index="item.index"
          @click.native="goto(item)"
        >
          <i v-if="item.icon" class="iconfont" :class="'icon' + item.icon"></i>
          <span slot="title" style="padding-left: 3px">{{ item.label }}</span>
        </el-menu-item>
        <el-submenu v-else :key="idx" :index="item.index">
          <template slot="title">
            <i
              v-if="item.icon"
              class="iconfont"
              :class="'icon' + item.icon"
            ></i>
            {{ item.label }}
          </template>
          <el-menu-item
            style="margin-left: 5px"
            v-for="(sub, idx) in item.children"
            :key="idx"
            :index="sub.index"
            @click.native="goto(sub)"
          >
            <!-- {{sub.label}} -->
            <i v-if="sub.icon" class="iconfont" :class="'icon' + sub.icon"></i>
            <span slot="title">{{ sub.label }}</span>
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data() {
    return {
      current: '',
      menus: [
        {
          icon: 'shouye',
          label: '首页',
          link: '/',
          index: 'index'
        },
        // {
        //   icon: 'ziyuanxhdpi',
        //   label: '报警管理',
        //   link: '/alarm',
        //   index: 'alarm'
        // },
        {
          icon: '10tongzhiliebiao',
          label: '工单管理',
          index: 'orders',
          children: [
            {
              label: '台席工单',
              link: '/orders/workorder',
              index: 'workorder-orders',
              icon: 'youjiantou'
            },
            {
              label: '计划工单',
              link: '/orders/planorder',
              index: 'planorder-orders',
              icon: 'youjiantou'
            },
            {
              label: '报警工单',
              link: '/orders/alarmorder',
              index: 'alarmorder-orders',
              icon: 'youjiantou'
            },
            {
              label: '服务订单',
              link: '/orders/service',
              index: 'service-orders',
              icon: 'youjiantou'
            }
          ]
        },
        {
          icon: 'buchongiconsvg06',
          label: '呼叫记录',
          index: 'record',
          children: [
            {
              label: '呼叫记录列表',
              link: '/record/recordList',
              index: 'record-list',
              icon: 'youjiantou'
            },
          ]
        },
        {
          icon: "yonghu",
          label: '服务对象管理',
          index: "men",
          children: [
            {
              label: "所有老人",
              link: "/men/olderList",
              index: "men-olders",
              icon: 'youjiantou'
            },
          ]
        },
        {
          icon: "shebeileixing",
          label: '综合登记',
          index: "approve",
          children: [
            {
              label: "人脸信息申请登记",
              link: "/approve/approveFaceList",
              index: "approve-list",
              icon: 'youjiantou'
            },

          ]
        }
      ]
    }
  },
  methods: {
    goto(item) {
      item.link && this.routeTo(item.link)
    },
    refresh() {
      let checkItem = item => {
        let cur = item.link === this.$route.path || (item.link !== '/' && _.startsWith(this.$route.path, item.link))
        if (cur) {
          this.current = item.index
        }
        return cur
      }
      for (let item of this.menus) {
        if (item.children) {
          for (let sub of item.children) {
            if (checkItem(sub)) return
          }
        } else {
          if (checkItem(item)) return
        }
      }
      this.current = null
    }
  },
  mounted() {
    this.refresh()
  },
  watch: {
    '$route'() {
      this.refresh()
    }
  }
}
</script>
